// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"22":"23bf43d80fc4a2eda7c3","532":"4ab46dc85d457f40d633","641":"89d556efc183810281c9"}[chunkId] + ".js";
};